import { Popup } from '../../../../../hexagon/models/PopupModel';

export const aPopup: Popup = {
    title: 'popup fr',
    content: 'qdqsd',
    cta: {
        label: 'valider',
        href: 'https://www.google.com',
    },
    ctaClose: {
        label: 'fermer',
    },
};
